import { getPaginatedData } from "src/hooks/structureTable";

/**
 * Obtiene los clientes para las busquedas
 * @param {JSON} filtrosClientes 
 * @returns 
 */
export const clientesForSearch = async (filtrosClientes) => {
  let clientes = [];
  if (localStorage.getItem("clientesForSearch")) {
      clientes = JSON.parse(localStorage.getItem("clientesForSearch"));
  } else {
      clientes = await getPaginatedData(false, false, filtrosClientes);
      localStorage.setItem("clientesForSearch", JSON.stringify(clientes));
  }

  return clientes;
};

/**
 * Obtiene cuentas personas fisicas
 * @param {JSON} filtrosClientes 
 * @returns 
 */
export const cuentasFisicasForSearch = async (filtrosClientes) => {
  let tecnicos = [];
  if (localStorage.getItem("cuentasFisicasForSearch")) {
    tecnicos = JSON.parse(localStorage.getItem("cuentasFisicasForSearch"));
  } else {
    tecnicos = await getPaginatedData(false, false, filtrosClientes);
      localStorage.setItem("cuentasFisicasForSearch", JSON.stringify(tecnicos));
  }

  return tecnicos;
};

/**
 * Obtiene los articulos para las busquedas
 * @param {JSON} filtrosClientes 
 * @returns 
 */
export const articulosForSearch = async (filtrosArticulos) => {
  let articulos = [];
  if (localStorage.getItem("articulosForSearch")) {
    articulos = JSON.parse(localStorage.getItem("articulosForSearch"));
  } else {
    articulos = await getPaginatedData(false, false, filtrosArticulos);
    localStorage.setItem("articulosForSearch", JSON.stringify(articulos));
  }

  return articulos;
};

/**
 * Obtiene los estados de informes
 * @param {JSON} filtrosEstados 
 * @returns 
 */
export const estadosInformesForSearch = async (filtrosEstados) => {
  let estados = [];
  if (localStorage.getItem("estadosInformesForSearch")) {
    estados = JSON.parse(localStorage.getItem("estadosInformesForSearch"));
  } else {
    estados = await getPaginatedData(false, false, filtrosEstados);
    localStorage.setItem("estadosInformesForSearch", JSON.stringify(estados));
  }

  return estados;
};



